import React, { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
//Style sheet for image gallery
import "react-image-gallery/styles/css/image-gallery.css";
import HoverButton from "../components/HoverButton";
import { RiFileEditLine, RiFileEditFill } from "react-icons/ri";
import BuckForm from "./BuckForm";
import { createDeepClone } from "../utils/utils";

const defaultFormDataErrors = {
    "nameError": '',
    "primaryProfileImageError": '',
    "topSixProfileImageError": '',
    "ageError": '',
    "sizeError": '',
    "pointsError": '',
    "classificationError": '',
    "notesErrorError": '',
    "privateNotesError": '',
    "publishedError": '',
};

const defaultFormData = {
    "name": '',
    "images": [],
    "primaryProfileImage": false,
    "topSixProfileImage": false,
    "age": '',
    "size": '',
    "points": '',
    "classification": '',
    "isBuck": true,
    "notes": '',
    "privateNotes": '',
    "published": false,
};

function BuckProfile({ buck, currentProfile, site, isMobile, style }) {
    const [editBuck, setEditBuck] = useState(false);
    const [formData, setFormData] = useState(createDeepClone(defaultFormData));
    const [formDataErrors, setFormDataErrors] = useState(createDeepClone(defaultFormDataErrors));
    const [formError, setFormError] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [changesMade, setChangesMade] = useState(false);

    useEffect(() => {
        if(buck) {
            let updatedFormData = {};
            Object.keys(defaultFormData).map((key) => {
                if(buck.hasOwnProperty(key) && buck[key] !== undefined) {
                    Object.assign(updatedFormData, { [key]: buck[key] });
                } else {
                    Object.assign(updatedFormData, { [key]: defaultFormData[key] });
                }
                return true;
            });
            setFormData(updatedFormData);
        }
    }, [buck]);

    const buckImages = buck.images.map((image) => {
        return({
            original: image,
            thumbnail: image,
        });
    });

    return (
        <div style={isMobile ? { ...style } : { ...style, "display": "flex", "alignItems": "center", "justifyContent": "center" }}>
            {currentProfile && currentProfile.isAdmin && editBuck ? (
                <BuckForm 
                    isMobile={isMobile} 
                    handleChange={(e) => { setChangesMade(true); setSubmitted(false); setFormError(''); let updatedFormData = { ...formData, ...e}; setFormData(updatedFormData); }}
                    formData={formData} 
                    formDataErrors={formDataErrors}
                    formError={formError}
                    submitted={submitted}
                    changesMade={changesMade}
                    images={formData.images}
                    handleImageChange={(e) => { setChangesMade(true); setSubmitted(false); setFormError(''); let updatedFormData = { ...formData, "images": e }; setFormData(updatedFormData); }}
                    onCancel={() => { setChangesMade(false); setFormError(''); setEditBuck(false); setFormDataErrors(createDeepClone(defaultFormDataErrors)); setSubmitted(false); }}
                    onSubmit={() => {
                        setSubmitted(true);
                        setFormError('');
                        site.updateBuck(currentProfile.accessToken, formData).then((response) => {
                            if(!response) {
                                setFormError('Failed to save edits to buck, please refresh the page and try again.')
                            }
                        }); 
                    }}
                    newBuck={false}
                />
            ) : (
                <React.Fragment>
                    {isMobile && currentProfile && currentProfile.isAdmin ? (
                        <div>
                            <HoverButton
                                normalIcon={<RiFileEditLine style={{ "transform": "scale(2.5)", "color": "grey" }} className="ai-edit-icon" />}
                                hoverIcon={<RiFileEditFill style={{ "transform": "scale(2.5)", "color": "black" }} className="ai-edit-icon" />}
                                updateParent={() => { setEditBuck(!editBuck); }}
                                title={`Edit ${buck.name}`}
                                style={{ "alignItems": "top", "paddingRight": "16px", "width": "100%", "justifyContent": "right" }}
                            />
                        </div>
                    ) : null}
                    <div style={{ "width": "100%" }}>
                        <ImageGallery
                            items={buckImages}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            showNav={false}
                        />
                    </div>
                    <div style={{ "display": "flex" }}>
                        <div style={isMobile ? {} : { "marginLeft": "48px" }}>
                            <h1 style={{ "marginBottom": "32px" }}><b>{buck.name}</b></h1>
                            <div style={isMobile ? {} : { "display": "flex"}}>
                                <div>
                                    <h4><b>Classification:</b></h4>
                                    <p>{buck.classification}</p>
                                </div>
                                <div style={isMobile ? {} : { "marginLeft": "64px", "width": "90px" }}>
                                    <h4><b>Age:</b></h4>
                                    <p>{buck.age} years old</p>
                                </div>
                                <div style={isMobile ? {} : { "marginLeft": "64px"}}> 
                                    <h4><b>Points:</b></h4>
                                    <p>{buck.points} points</p>
                                </div>
                            </div>
                            <div style={isMobile ? {} : { "display": "flex"}}>
                                <div>
                                    <h4><b>Notes:</b></h4>
                                    <p>{buck.notes}</p>
                                </div>
                                {currentProfile && currentProfile.isAdmin ? (
                                    <div style={isMobile ? {} : { "marginLeft": "64px"}}>
                                        <h4><b>Private Notes:</b></h4>
                                        <p>{buck.privateNotes}</p>
                                    </div>
                                ) : null}
                                {currentProfile && currentProfile.isAdmin ? (
                                    <div style={isMobile ? {} : { "marginLeft": "64px"}}>
                                        <h4><b>Published:</b></h4>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        {!isMobile && currentProfile && currentProfile.isAdmin ? (
                            <div>
                                <HoverButton
                                    normalIcon={<RiFileEditLine style={{ "transform": "scale(2.5)", "color": "grey" }} className="ai-edit-icon" />}
                                    hoverIcon={<RiFileEditFill style={{ "transform": "scale(2.5)", "color": "black" }} className="ai-edit-icon" />}
                                    updateParent={() => { setEditBuck(!editBuck); }}
                                    title={`Edit ${buck.name}`}
                                    style={{ "alignItems": "top", "marginTop": "32px", "width": "100%", "justifyContent": "right" }}
                                />
                            </div>
                        ) : null}
                    </div>
                </React.Fragment>
            )}

        </div>
    );
};

export default BuckProfile;